export default class WaypointProperties {
    name: string
    icon: string
    colour: string
    proximityAlarm: number|null
    constructor(name: string, icon: string, colour: string, proximityAlarm: number|null) {
        this.name = name
        this.icon = icon
        this.colour = colour
        this.proximityAlarm = proximityAlarm
    }
}